import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { SSOLogoutPage } from './sso-logout'
import { SSOSettingsPage } from './sso-settings'

const SSOPageRaw = ({ match }) => {
  return (
    <Switch>
      <Route exact path={`${match.path}/logout`} render={() => <SSOLogoutPage />} />
      <Route exact path={`${match.path}/settings`} render={() => <SSOSettingsPage />} />
    </Switch>
  )
}

export const SSOPageRoutes = withRouter(SSOPageRaw)
